import React from 'react';
import { Flex } from '@components/Flex';
import { Text } from '@components/typography';
import { MainWrapper, ContentWrapper, QuoteWrapper, LogoWrapper, CustomCloudImage } from './FeaturedSection.styles';
import { useTranslation } from 'react-i18next';
export const FeaturedSection = () => {
  const { t } = useTranslation('ourStory');
  const featuredData = t('featuredData');

  const featureLogos = [
    'our-story/logos/vogue_logo.svg',
    'our-story/logos/new-york-times_logo.svg',
    'our-story/logos/wsj_logo.svg',
    'our-story/logos/gma-logo.svg',
    'our-story/logos/today-logo.svg',
    'our-story/logos/buzzfeed-logo.svg',
    'our-story/logos/brides_logo.svg',
    'our-story/logos/fortune_magazine_logo.svg',
    'our-story/logos/forbes_logo.svg',
    'our-story/logos/cosmpolitan-logo.svg',
    'our-story/logos/insider-logo.svg',
    'our-story/logos/w-g-logo.svg',
    'our-story/logos/bustle_logo.svg',
    'our-story/logos/realsimple-logo.svg',
  ];
  return (
    <MainWrapper justifyContent="center" paddingTop={11} paddingBottom={[8, 11]}>
      <ContentWrapper paddingX={[4, 10]}>
        <QuoteWrapper marginBottom={4}>
          <Text tagName="h2" variant="hed56" color="neutra6">
            {featuredData.title}
          </Text>
        </QuoteWrapper>
        <LogoWrapper justifyContent="space-between" alignItems="center">
          {featureLogos.map((logo, index) => (
            <Flex style={{ display: 'inline-flex' }} key={index} paddingX={[4, 6]} paddingY={[6, 7, 8]}>
              <CustomCloudImage width="100%" height="100%" src={logo} />
            </Flex>
          ))}
        </LogoWrapper>
      </ContentWrapper>
    </MainWrapper>
  );
};
